const messages = {
  confirmTitle: 'Are you sure?',
  confirmSave: 'Yes',
  confirmCancel: 'No',
  save: 'Save',
  cancel: 'Close'
};

export default messages;
